import { createRouter, createWebHistory } from 'vue-router'

import { useToast } from '@/composables/useToast'

import { routes, type MtpRouteMeta } from './routes'
import { installChunkRecovery } from './chunkRecovery'
import { installGuards } from './guards'

declare module 'vue-router' {
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  interface RouteMeta extends MtpRouteMeta {}
}

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(_to, _from, saved) {
    // 前进后退恢复滚动位置；新导航回到顶部。
    // 列表页 keepAlive + 恢复滚动 = 从详情返回时停在原来那一行。
    return saved ?? { top: 0 }
  },
})

installGuards(router)

/**
 * 分包拉不下来时自愈一次，还不行就说人话 —— 别把白屏留给用户（#101）。
 *
 * 钥匙放 `sessionStorage`：重载会清空内存，而这一次重试的事实必须活过那次重载，
 * 否则就是无限刷新循环 —— 比白屏更糟。
 */
const RETRY_KEY = 'mtp.chunk-retry'
installChunkRecovery(router, {
  reload: () => window.location.reload(),
  getFlag: () => window.sessionStorage.getItem(RETRY_KEY),
  setFlag: (v) => window.sessionStorage.setItem(RETRY_KEY, v),
  clearFlag: () => window.sessionStorage.removeItem(RETRY_KEY),
  onGiveUp: (message) => useToast().error(message),
})

export default router
